import React, { useState, useEffect } from 'react';

function ScaledImage(props) {
  const [dimensions, setDimensions] = useState({ width: props.width || 0, height: props.height || 0});
//   console.log(props)
  const scale = props.rate; // 缩放比例

  useEffect(() => {
    const img = new Image();
    // console.log(props.src)
    img.src = props.src;
    img.onload = () => {
      setDimensions({ width: img.width, height: img.height });
    };
  }, [props.src]);

  let style = props.style || {};
  return (
    <img 
      src={props.src}
      onClick={props.onClick}
      style={{
        width: `${dimensions.width * scale}px`, 
        height: `${dimensions.height * scale}px`,
        ...style,
      }} 
      alt="description"
    />
  );
}

export default ScaledImage;